// 计算移动端粘性定位的辅助函数（独立于Alpine组件）
function calculateTagBarStickyTop() {
  // 只在移动端计算
  if (window.innerWidth > 768) {
    return;
  }

  // 查找元素1：announcement-bar announcement-bar--multiple
  const announcementBar =
    document.querySelector(".announcement-bar.announcement-bar--multiple") || document.querySelector(".announcement-bar--multiple") || document.querySelector(".announcement-bar");

  // 查找元素2：header header--bordered
  const header = document.querySelector(".header.header--bordered") || document.querySelector(".header--bordered") || document.querySelector(".header");

  // 查找元素3：mobile-tag-bar-priority
  const mobileTagBarPriority = document.querySelector(".mobile-tag-bar-priority");

  // 计算高度
  const height1 = announcementBar ? announcementBar.offsetHeight : 0;
  const height2 = header ? header.offsetHeight : 0;
  const height3 = mobileTagBarPriority ? mobileTagBarPriority.offsetHeight : 0;

  // 计算粘性定位位置：元素1的高 + 元素2的高 - 元素3的高
  const stickyTop = height1 + height2 - height3 - 20;

  // 设置CSS变量并启用粘性定位
  const tagBar = document.querySelector(".tag-bar");
  if (tagBar) {
    tagBar.style.setProperty("--tag-bar-sticky-top", `${stickyTop}px`);
    // 添加类名以启用粘性定位
    tagBar.classList.add("tag-bar-sticky");
    console.log(`移动端粘性定位计算: ${height1} + ${height2} - ${height3} - 20 = ${stickyTop}px`);
  }
}

// 在 DOMContentLoaded 事件时计算粘性定位
function onDOMContentLoaded() {
  // 延迟执行，确保所有元素都已渲染
  setTimeout(() => {
    calculateTagBarStickyTop();
    console.log("DOMContentLoaded 完成，已计算移动端粘性定位");
  }, 100);
}

if (document.readyState === "loading") {
  // DOM 还在加载中，等待 DOMContentLoaded 事件
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  // DOM 已经加载完成，直接执行
  onDOMContentLoaded();
}

// 注册 Alpine.js 组件
document.addEventListener("alpine:init", () => {
  // 注册 BlackFriday 组件
  Alpine.data("blackFriday", () => ({
    block1FeaturedCollectionsId: "{{ section.settings.block1_featured_collections_id }}",
    block2FeaturedCollectionsId: "{{ section.settings.block2_featured_collections_id }}",
    block6ElementIds: "{{ section.settings.block6_element_ids }}",
    init() {
      console.log("BlackFriday 2025");

      // 如果配置了 Block1 Featured collections ID，则查询并插入
      if (this.block1FeaturedCollectionsId && this.block1FeaturedCollectionsId.trim() !== "") {
        this.loadFeaturedCollections("block1featuredCollections", this.block1FeaturedCollectionsId);
      }

      // 如果配置了 Block2 Featured collections ID，则查询并插入
      if (this.block2FeaturedCollectionsId && this.block2FeaturedCollectionsId.trim() !== "") {
        this.loadFeaturedCollections("block2featuredCollections", this.block2FeaturedCollectionsId);
      }

      // 如果配置了 Block6 Element IDs，则查询并移动到 imageWithReviews 容器
      if (this.block6ElementIds && this.block6ElementIds.trim() !== "") {
        this.loadBlock6Elements("imageWithReviews", this.block6ElementIds);
      }

      // 监听窗口大小改变，重新计算（使用防抖）
      // 注意：初始计算会在页面加载完成后执行
      let resizeTimer;
      const handleResize = () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          this.calculateStickyTop();
          // 同时调用独立函数，确保计算准确
          calculateTagBarStickyTop();
        }, 100);
      };
      window.addEventListener("resize", handleResize);
    },
    calculateStickyTop() {
      // 只在移动端计算
      if (window.innerWidth > 768) {
        return;
      }

      // 查找元素1：announcement-bar announcement-bar--multiple
      const announcementBar =
        document.querySelector(".announcement-bar.announcement-bar--multiple") ||
        document.querySelector(".announcement-bar--multiple") ||
        document.querySelector(".announcement-bar");

      // 查找元素2：header header--bordered
      const header = document.querySelector(".header.header--bordered") || document.querySelector(".header--bordered") || document.querySelector(".header");

      // 查找元素3：mobile-tag-bar-priority
      const mobileTagBarPriority = document.querySelector(".mobile-tag-bar-priority");

      // 计算高度
      const height1 = announcementBar ? announcementBar.offsetHeight : 0;
      const height2 = header ? header.offsetHeight : 0;
      const height3 = mobileTagBarPriority ? mobileTagBarPriority.offsetHeight : 0;

      // 计算粘性定位位置：元素1的高 + 元素2的高 - 元素3的高
      const stickyTop = height1 + height2 - height3 - 20;

      // 设置CSS变量并启用粘性定位
      const tagBar = document.querySelector(".tag-bar");
      if (tagBar) {
        tagBar.style.setProperty("--tag-bar-sticky-top", `${stickyTop}px`);
        // 添加类名以启用粘性定位
        tagBar.classList.add("tag-bar-sticky");
        console.log(`移动端粘性定位计算: ${height1} + ${height2} - ${height3} - 20 = ${stickyTop}px`);
      }
    },
    loadFeaturedCollections(refName, idsString) {
      const container = this.$refs[refName];
      if (!container) return;

      // 将 ID 字符串按 '|' 分割成数组
      const ids = (idsString || "")
        .split("|")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      if (ids.length === 0) return;

      let queryCount = 0;
      const maxQueries = 20;
      const queryInterval = 500; // 500ms

      const queryElement = () => {
        queryCount++;

        // 查找第一个存在的目标元素
        for (const id of ids) {
          const targetElement = document.getElementById(id);
          if (targetElement) {
            // 找到元素，直接移动到容器中并停止查询
            container.appendChild(targetElement);
            console.log(`Featured collections ${id} 已成功插入至 ${refName}`);

            // 如果是 block1featuredCollections，添加上下-40px的负边距
            if (refName === "block1featuredCollections") {
              container.style.marginTop = "-40px";
              container.style.marginBottom = "-40px";
            }

            return; // 停止查询
          }
        }

        // 如果未找到且未达到最大查询次数，继续查询
        if (queryCount < maxQueries) {
          setTimeout(queryElement, queryInterval);
        } else {
          console.warn("未找到 Featured collections 元素，已达到最大查询次数");
        }
      };

      // 开始查询
      queryElement();
    },
    loadBlock6Elements(refName, idsString) {
      const container = this.$refs[refName];
      if (!container) return;

      // 将 ID 字符串按 '|' 分割成数组
      const ids = (idsString || "")
        .split("|")
        .map((id) => id.trim())
        .filter((id) => id !== "");

      if (ids.length === 0) return;

      let queryCount = 0;
      const maxQueries = 20;
      const queryInterval = 500; // 500ms
      const foundIds = new Set(); // 记录已找到的元素 ID

      const queryElement = () => {
        queryCount++;

        // 查找所有存在的目标元素
        for (const id of ids) {
          // 如果已经找到并移动过，跳过
          if (foundIds.has(id)) continue;

          const targetElement = document.getElementById(id);
          if (targetElement) {
            // 找到元素，移动到容器中
            container.appendChild(targetElement);
            foundIds.add(id);
            console.log(`Block6 元素 ${id} 已成功移动到 ${refName}`);
          }
        }

        // 如果所有元素都已找到，停止查询
        if (foundIds.size === ids.length) {
          console.log(`Block6 所有元素已成功移动，共 ${foundIds.size} 个`);
          return;
        }

        // 如果未找到所有元素且未达到最大查询次数，继续查询
        if (queryCount < maxQueries) {
          setTimeout(queryElement, queryInterval);
        } else {
          console.warn(`Block6 查询结束，找到 ${foundIds.size}/${ids.length} 个元素，已达到最大查询次数`);
        }
      };

      // 开始查询
      queryElement();
    },
    scrollToTarget(targetRef, event) {
      // 如果 targetRef 为空，不执行滚动
      if (!targetRef || targetRef.trim() === "") {
        return;
      }

      // 如果点击的是按钮链接，不执行滚动，让链接正常跳转
      if (event && event.target && event.target.tagName === "A") {
        return;
      }

      // 阻止默认行为（如果有的话）
      if (event) {
        event.preventDefault();
      }

      // 通过 x-ref 查找目标元素
      const targetElement = this.$refs[targetRef];
      if (!targetElement) {
        console.warn(`未找到 x-ref="${targetRef}" 的元素`);
        return;
      }

      // 计算固定头部的高度
      // 尝试查找 announcement-bar（支持多种可能的类名）
      const announcementBar =
        document.querySelector(".announcement-bar--multiple") || document.querySelector(".announcement-bar") || document.querySelector('[class*="announcement-bar"]');

      // 尝试查找 header（支持多种可能的类名）
      const header = document.querySelector(".header--bordered") || document.querySelector(".header") || document.querySelector('[class*="header"]');

      let fixedHeaderHeight = 0;
      if (announcementBar) {
        fixedHeaderHeight += announcementBar.offsetHeight || 0;
      }
      if (header) {
        fixedHeaderHeight += header.offsetHeight || 0;
      }

      // 移动端：额外减去 mobile-tag-bar-grid 的高度（因为 mobile-tag-bar-grid 有粘性定位）
      if (window.innerWidth <= 768) {
        const mobileTagBarGrid = document.querySelector(".mobile-tag-bar-grid");
        if (mobileTagBarGrid) {
          fixedHeaderHeight += mobileTagBarGrid.offsetHeight || 0;
        }
      }

      // 获取目标元素的位置
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

      // 计算滚动位置（减去固定头部高度）
      const scrollPosition = targetPosition - fixedHeaderHeight;

      // 平滑滚动到目标位置
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    },
  }));
});

// 在页面加载完成后重新计算粘性定位（作为备用）
// 使用 window.load 确保所有资源（包括 defer 脚本）都已加载
function onPageLoad() {
  // 重新计算移动端粘性定位（延迟执行，确保所有元素都已完全渲染）
  // 这作为备用计算，因为某些元素可能在 DOMContentLoaded 时还未完全渲染
  setTimeout(() => {
    calculateTagBarStickyTop();
    console.log("页面完全加载完成，已重新计算移动端粘性定位");
  }, 200);
}

if (document.readyState === "complete") {
  // 页面已经完全加载，直接执行
  onPageLoad();
} else {
  // 等待页面完全加载
  window.addEventListener("load", onPageLoad);
}
